import React from "react";

import useTranslations from "../../../hooks/useTranslations";

import { FormStepProps } from "../../../screens/ReviewFormScreen";

import { RadioGroup, Radio } from "../../wombat-ui";
import { Controller } from "react-hook-form";
import { ReviewFullFragment } from '../../../graphql/generated/definitions';

const ReviewSettingsForm: React.FC<
  Omit<FormStepProps, "onNext" | "formState"> & {
    defaultValues?: ReviewFullFragment;
  }
> = ({ control }) => {
  const t = useTranslations();

  return (
    <Controller
      control={control}
      name="allowTemplateUpdateByCollaborator"
      id="allowTemplateUpdateByCollaborator"
      render={({ onChange, value, name }) => (
        <RadioGroup
          title={t("reviews.allowTemplateUpdateByCollaborator") as string}
          description={t("reviews.allowTemplateUpdateByCollaboratorDescription")}
        >
          <Radio
            id={`allowTemplateUpdateByCollaborator-true`}
            label={t("forms.actions.yes") as string}
            name={name}
            value={"true"}
            checked={value}
            onClick={() => onChange(true)}
          />
          <Radio
            id={`allowTemplateUpdateByCollaborator-false`}
            label={t("forms.actions.no") as string}
            name={name}
            value={"false"}
            checked={!value}
            onClick={() => onChange(false)}
          />
        </RadioGroup>
      )}
    >

    </Controller>
  );
};

export default React.memo(ReviewSettingsForm);
